import VisaIcon from "assets/credit-card/Visa.svg";
import MasterCardIcon from "assets/credit-card/mastercard-old.svg";
import AmexIcon from "assets/credit-card/AmericanExpress.svg";
import DiscoverIcon from "assets/credit-card/Discover.svg";
import DinersIcon from "assets/credit-card/DinersClub.svg";

interface CardType {
    id: string;
    label: string;
    icon: string;
}

export const ACCEPTED_CARDS_CONFIG: CardType[] = [
    { id: "Visa", label: "Visa", icon: VisaIcon },
    { id: "MasterCard", label: "MasterCard", icon: MasterCardIcon },
    { id: "AmericanExpress", label: "American Express", icon: AmexIcon },
    { id: "Discover", label: "Discover", icon: DiscoverIcon },
    { id: "DinersClub", label: "Diners Club", icon: DinersIcon },
];

/* ══════════════════════════════════════════════════════════════════════════
   Brand naming.

   The payment provider is not consistent about how it spells a brand —
   "visa", "Visa", "MasterCard", "amex" and "american_express" all arrive —
   and the card face rendered whatever came back, uppercased. Normalising on
   letters only means one card does not read AMEX while the next reads
   AMERICAN EXPRESS.
   ══════════════════════════════════════════════════════════════════════════ */

const normalise = (brand?: string | null) =>
    String(brand ?? "").toLowerCase().replace(/[^a-z]/g, "");

const BRAND_LABELS: Record<string, string> = {
    visa: "Visa",
    mastercard: "Mastercard",
    amex: "American Express",
    americanexpress: "American Express",
    discover: "Discover",
    diners: "Diners Club",
    dinersclub: "Diners Club",
    jcb: "JCB",
    unionpay: "UnionPay",
    maestro: "Maestro",
    elo: "Elo",
    hipercard: "Hipercard",
    eftposau: "Eftpos Australia",
};

/**
 * Display name for a brand string. Falls back to the raw value title-cased,
 * so an unmapped brand still reads as a name rather than as a slug.
 */
export const getCardBrandLabel = (brand?: string | null): string => {
    const key = normalise(brand);
    if (BRAND_LABELS[key]) return BRAND_LABELS[key];
    const raw = String(brand ?? "").trim();
    if (!raw) return "Card";
    return raw.charAt(0).toUpperCase() + raw.slice(1);
};
